module.exports = __webpack_public_path__ + "media/components/star-rating/static/yellow/0.75-5518511d79dc8f6960709e08f7cabcc4.svg";